<template>
  <CheckWarrantBalToGL />
</template>

<script>
import CheckWarrantBalToGL from '../../../components/Gl/CheckWarrantBalToGL/CheckWarrantBalToGL.vue';

export default {
  components: {
    CheckWarrantBalToGL,
  },
};

</script>
